/* 当前位置路径 */
import React from 'react'
import classnames from 'classnames'
import Link from 'next/link'
import styles from './index.module.scss'

import getLinkHref from 'lib/get-link-href'

interface IProps {
  /* 当前页面路径 */
  path: {
    [prop: string]: string
  }[]
  hideLine?: boolean
  style?: React.CSSProperties
  className?: string
  handleCrumbClick?: (path: { [prop: string]: string }) => void
}

export default function Breadcrumb({
  path,
  hideLine = false,
  style,
  className,
  handleCrumbClick,
}: IProps) {
  return (
    <div style={style} className={classnames(className, styles.root)}>
      <div>
        <span className={styles.pos}>当前位置：</span>
        {path.map(
          (
            text: {
              [prop: string]: string
            },
            index: number
          ) => (
            <span
              key={text.name}
              className={classnames('tw-leading-20', {
                [styles['pos-item']]: true,
                icon: index !== path.length - 1,
                'icon-arrow-ic-r': index !== 0,
              })}
            >
              {text.href && text.as ? (
                <Link href={text.href} as={getLinkHref(text.as)}>
                  <a
                    target="_blank"
                    onClick={() =>
                      typeof handleCrumbClick === 'function' &&
                      handleCrumbClick(text)
                    }
                  >
                    {/*{text.src && (
                      <Image
                        src={text.src}
                        height={20}
                        width={20}
                        autoPixelRatio={true}
                        className="tw-align-bottom"
                      />
                    )}*/}
                    {text.name}
                  </a>
                </Link>
              ) : (
                text.name
              )}
            </span>
          )
        )}
      </div>
    </div>
  )
}
